import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("ss_cookies")) setShow(true);
  }, []);

  const save = async (analytics, marketing) => {
    localStorage.setItem("ss_cookies", JSON.stringify({ analytics, marketing, ts: Date.now() }));
    try { await api.post("/consent", { necessary: true, analytics, marketing }); } catch {}
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-6 md:bottom-6 md:right-auto md:max-w-md z-[60] bg-white border border-zinc-200 rounded-2xl shadow-2xl p-6 fade-in-up" data-testid="cookie-banner">
      <div className="font-display font-bold text-lg mb-2">Cookies a soukromí</div>
      <p className="text-sm text-zinc-600 leading-relaxed mb-4">Používáme cookies pro funkčnost webu, analýzu návštěvnosti a personalizaci obsahu. Své nastavení můžete kdykoliv změnit.</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <button onClick={() => save(true, true)} className="btn-primary flex-1 py-2.5 rounded-full text-sm font-semibold" data-testid="cookie-accept-all">Přijmout vše</button>
        <button onClick={() => save(false, false)} className="flex-1 py-2.5 rounded-full text-sm font-semibold border border-zinc-200 hover:bg-zinc-50" data-testid="cookie-reject">Jen nutné</button>
      </div>
      <a href="/cookies" className="block mt-3 text-xs text-zinc-500 hover:text-blue-600">Více o cookies</a>
    </div>
  );
}
